export default [
  {
    path: '/account/index',
    name: 'AccountIndex',
    component: () => import('@/views/Account/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/account/personalInfo',
    name: 'AccountPersonalInfo',
    component: () => import('@/views/Account/PersonalInfo.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/account/personalInfo/edit',
    name: 'AccountEditPersonalInfo',
    component: () => import('@/views/Account/EditPersonalInfo.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/account/changePassword',
    name: 'AccountChangePassword',
    component: () => import('@/views/Account/ChangePassword.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/account/importReservation',
    name: 'AccountImportReservation',
    component: () => import('@/views/Account/ImportReservation.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/account/sharingReservation',
    name: 'AccountSharingReservation',
    component: () => import('@/views/Account/SharingReservation.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/account/acceptedSharingReservation',
    name: 'AccountAcceptedSharingReservation',
    component: () => import('@/views/Account/AcceptedSharingReservation.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/account/takeRoomCard/:serno',
    name: 'AccountTakeRoomCard',
    props: true,
    component: () => import('@/views/Account/TakeRoomCard.vue'),
    meta: {
      requiresAuth: true,
    },
  },
];
